module.exports = __webpack_public_path__ + "static/media/AriaLogoText.39a5d4c8.svg";